module.exports = __webpack_public_path__ + "static/banner1-65e3984c2be00c93f0d393add70ac6c0.jpg";